import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ColumnExportButton, Table } from 'barnyard/components';
import _ from 'lodash';


const columns = [{
  Header: 'Date',
  accessor: 'date'
}, {
  Header: 'Supplier',
  accessor: 'supplier_name',
}, {
  Header: 'Clinic',
  accessor: 'buyer_name'
}, {
  Header: 'Bill To',
  accessor: 'bill_to'
}, {
  Header: 'Link To Order',
  accessor: 'id',
  Cell: ({ value }) => <Link to={`/corporate/history/orders/?checkout_id=${value}`}>View Order</Link>,
  includeInExport: false
}];


const WrongBillToTable = ({ checkouts, includeExport }) => (
  <Table
    actions={includeExport
      && <div className='u-paddingTop10'>
        <ColumnExportButton
          filename='Vetcove_Wrong_Bill_Tos.csv'
          columns={columns}
          data={checkouts}
        >
          Download
        </ColumnExportButton>
      </div>
    }
    size='small'
    columns={columns}
    data={checkouts}
    pageSize={_.size(checkouts) || 10}
    showPagination={false}
  />
);

WrongBillToTable.propTypes = {
  checkouts: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default WrongBillToTable;
